import styled from "styled-components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { selectUser } from "../../features/userSlice";
import { subscribeNotifications, markNotificationsRead } from "../../utils/communities";

dayjs.extend(relativeTime);

const ICONS = {
    join_request: "🗓️",
    join: "🙌",
    approved: "✅",
    post: "📝",
    comment: "💬",
    banned: "🚫",
    removed: "➖",
    owner: "👑",
    info: "🔔",
};

export const ContentsNotification = () => {
    const user = useSelector(selectUser);
    const history = useHistory();
    const [notifs, setNotifs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = subscribeNotifications(user?.uid, (list) => {
            setNotifs(list);
            setLoading(false);
        });
        return unsub;
    }, [user?.uid]);

    const unread = notifs.filter((n) => !n.read).length;

    const handleOpen = (n) => {
        markNotificationsRead(user?.uid).catch(() => {});
        if (n.communitySlug) history.push(`/c/${n.communitySlug}`);
        else if (n.postId && n.communitySlug) history.push(`/c/${n.communitySlug}`);
        else history.push("/home");
    };

    const markAll = async () => {
        await markNotificationsRead(user?.uid);
    };

    return (
        <Container>
            <div className="heading">
                <span>Notifications</span>
                <p onClick={markAll}>Mark All As Read</p>
            </div>

            {loading && <div className="empty-note">Loading notifications...</div>}

            {!loading && notifs.length === 0 && (
                <div className="empty-note">
                    <div className="big">🔔</div>
                    No notifications yet. Activity from communities you join will show up here.
                </div>
            )}

            {notifs.map((n) => (
                <div key={n.id} className={`subdiv ${n.read ? "" : "unread"}`} onClick={() => handleOpen(n)}>
                    <div className="icon">{ICONS[n.type] || ICONS.info}</div>
                    <div className="text">
                        <p>{n.communityName || n.fromName || "Fellora"}</p>
                        <span>{n.message || "New activity"}</span>
                        {n.communitySlug && <em>r/{n.communitySlug}</em>}
                        <small className="time">{n.createdAt ? dayjs(n.createdAt.toMillis()).fromNow() : ""}</small>
                    </div>
                    {!n.read && <span className="dot" />}
                </div>
            ))}
        </Container>
    );
};

const Container = styled.div`
    margin-top: 4.07rem;
    width: 35.75rem;
    background: white;

    .heading {
        display: flex;
        justify-content: space-between;
        min-height: 1.625rem;
        padding: 0.2rem 0.8rem 0.5rem;
        color: #282829;
        font-weight: 600;
        font-size: 0.97rem;
        border-bottom: 1px solid rgb(222, 224, 225);

        p {
            font-size: 13px;
            color: #1DA1F2;
            font-weight: 600;
            cursor: pointer;
            &:hover { text-decoration: underline; }
        }
    }

    .subdiv {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 0.9rem 1rem;
        border-bottom: 1px solid rgb(222, 224, 225);
        cursor: pointer;
        position: relative;

        &:hover { background-color: #faf7f2; }

        &.unread { background-color: #f0f7ff; }

        .icon {
            width: 40px; height: 40px;
            flex-shrink: 0;
            border-radius: 50%;
            background: linear-gradient(135deg, #1DA1F2, #0d8ecf);
            color: white;
            display: flex; align-items: center; justify-content: center;
            font-size: 18px;
        }

        .text {
            flex: 1;
            min-width: 0;

            p { margin: 0; font-size: 12px; color: #999; }
            span { display: block; font-size: 14px; color: #282829; font-weight: 500; margin: 2px 0; }
            em { font-style: normal; font-size: 12px; color: #1DA1F2; font-weight: 600; }
            .time { display: block; font-size: 11px; color: #aaa; margin-top: 2px; }
        }

        .dot {
            width: 9px; height: 9px;
            flex-shrink: 0;
            border-radius: 50%;
            background: #e53935;
            margin-top: 6px;
        }
    }

    .empty-note {
        padding: 3rem 1rem;
        text-align: center;
        color: #999;
        font-size: 14px;

        .big { font-size: 34px; margin-bottom: 8px; }
    }
`;